import React from 'react';
import './About.css';

const IconAward = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="8" r="6"/>
    <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/>
  </svg>
);

const IconShieldCheck = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <polyline points="9 12 11 14 15 10"/>
  </svg>
);

const IconMap = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/>
    <line x1="9" y1="3" x2="9" y2="18"/>
    <line x1="15" y1="6" x2="15" y2="21"/>
  </svg>
);

const IconGear = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
);

const About: React.FC = () => {
  return (
    <div className="about">

      <section className="about-hero">
        <div className="container">
          <h1>Quiénes Somos</h1>
          <p>Automatización Básculas y Control, S.A. de C.V. — Zapopan, Jalisco</p>
        </div>
      </section>

      <section className="about-story">
        <div className="container about-story-grid">
          <div className="about-story-text">
            <h2>Nuestra Historia</h2>
            <p>
              Fundada en 1994 en Zapopan, Jalisco, llevamos más de 30 años especializándonos en
              soluciones de pesaje, automatización y control para la industria mexicana.
              Lo que comenzó como una empresa de venta y servicio de equipo de pesaje se ha
              convertido en un integrador de sistemas con presencia nacional.
            </p>
            <p>
              Hoy atendemos a clientes en sectores como alimentos, construcción, agroindustria,
              manufactura y logística. Nuestro equipo técnico realiza instalaciones, calibraciones
              y mantenimiento preventivo y correctivo en toda la República Mexicana, con sucursales
              en Guadalajara, Ciudad de México, Monterrey y San Luis Potosí.
            </p>
            <p>
              Representamos marcas líderes mundiales — <strong>Avery Weigh-Tronix</strong>,{' '}
              <strong>Rice Lake</strong> y <strong>Dillon</strong> — y respaldamos cada equipo
              con refacciones originales, soporte técnico directo y garantía.
            </p>
          </div>
          <div className="about-story-image">
            <img src="/about-company.png" alt="" loading="lazy" />
          </div>
        </div>
      </section>

      <section className="about-differentiators">
        <div className="container">
          <h2>Lo que nos distingue</h2>
          <div className="differentiators-grid">
            <div className="differentiator-card">
              <div className="differentiator-icon"><IconAward /></div>
              <h3>Más de 30 años de experiencia</h3>
              <p>
                Desde 1994 hemos instalado y dado servicio a cientos de sistemas de pesaje
                en toda la República, acumulando experiencia en los sectores más exigentes.
              </p>
            </div>
            <div className="differentiator-card">
              <div className="differentiator-icon"><IconShieldCheck /></div>
              <h3>Calibración certificada</h3>
              <p>
                Realizamos calibración y verificación metrológica con equipos trazables a
                patrones nacionales. Emitimos certificados para auditorías de calidad.
              </p>
            </div>
            <div className="differentiator-card">
              <div className="differentiator-icon"><IconMap /></div>
              <h3>Cobertura nacional</h3>
              <p>
                Contamos con técnicos en Zapopan/Guadalajara, Ciudad de México, Monterrey y
                San Luis Potosí para atender instalaciones y emergencias en todo el país.
                También ofrecemos asesoría remota.
              </p>
            </div>
            <div className="differentiator-card">
              <div className="differentiator-icon"><IconGear /></div>
              <h3>Integración a la medida</h3>
              <p>
                No solo vendemos equipo: diseñamos e integramos sistemas completos adaptados
                al proceso del cliente, desde la báscula hasta el software de control.
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;
